// extracted by mini-css-extract-plugin
module.exports = {"user-menu":"user-menu-tWwak","menu":"menu-2Gfjk","account":"account-3UZMe","avatar":"avatar-y1g6K"};